import { render } from "./UserBox.vue?vue&type=template&id=42db71bd&scoped=true"
import script from "./UserBox.vue?vue&type=script&lang=js"
export * from "./UserBox.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./UserBox.vue?vue&type=style&index=0&id=42db71bd&lang=scss&module=true"
cssModules["$style"] = style0
import "./UserBox.vue?vue&type=style&index=1&id=42db71bd&lang=scss&scoped=true"

import exportComponent from "/usr/share/nginx/production/frontend/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules],['__scopeId',"data-v-42db71bd"]])

export default __exports__